export default "<h2 style=\"color: black;\">\n  You are not authorized to access this resource.\n</h2>\n";